import React from "react";
import {useCamera} from "@react-sigma/core";

import {FiDisc, FiMinus, FiPlus} from "react-icons/fi";

export const TheCellMapZoomControl = () => {
  const {zoomIn, zoomOut, reset} = useCamera({duration: 200, factor: 1.5});

  return (
    <>
      <div className="btn-group-vertical" role="group" aria-label="Zoom controls button group">
        <button onClick={() => zoomIn()} type="button" className="btn btn-outline-light" title="Zoom In">
          <FiPlus/>
        </button>
        <button onClick={() => reset()} type="button" className="btn btn-outline-light" title="See whole graph">
          <FiDisc/>
        </button>
        <button onClick={() => zoomOut()} type="button" className="btn btn-outline-light" title="Zoom Out">
          <FiMinus/>
        </button>
      </div>
    </>
  );
};
